(function () {
  'use strict';

  if (window.__proctersBundleGuidanceReady) return;
  window.__proctersBundleGuidanceReady = true;

  var tooltip = null;
  var activeButton = null;
  var priorDescription = null;
  var dismissalTimer = null;
  var removalTimer = null;
  var highlightedLinks = [];
  var tooltipId = 'ph-bundle-guidance-tooltip';
  var scrollToChoiceTimer = null;
  var releaseScrollTimer = null;
  var guidedScrollActive = false;

  function ensureTooltip() {
    if (tooltip) return tooltip;
    tooltip = document.createElement('div');
    tooltip.id = tooltipId;
    tooltip.className = 'ph-bundle-guidance';
    tooltip.setAttribute('role', 'status');
    tooltip.setAttribute('aria-live', 'polite');
    tooltip.hidden = true;
    tooltip.innerHTML =
      '<svg class="ph-bundle-guidance__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.5" />' +
        '<path d="M12 7.5v6.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />' +
        '<circle cx="12" cy="17.2" r="1" fill="currentColor" />' +
      '</svg>' +
      '<span class="ph-bundle-guidance__text">Please choose your product options before adding to your basket.</span>';
    document.body.appendChild(tooltip);
    return tooltip;
  }

  function isWaitingForChoices(button) {
    return !!button && !button.disabled &&
      button.getAttribute('data-ph-bundle-choice-pending') === 'true' &&
      button.getAttribute('aria-disabled') === 'true';
  }

  function resetHighlights() {
    highlightedLinks.forEach(function (link) {
      link.classList.remove('ph-bundle-options-attention');
    });
    highlightedLinks = [];
  }

  function resetButtonDescription() {
    if (!activeButton) return;
    if (priorDescription === null) activeButton.removeAttribute('aria-describedby');
    else activeButton.setAttribute('aria-describedby', priorDescription);
    activeButton = null;
    priorDescription = null;
  }

  function hideGuidance(immediate) {
    window.clearTimeout(dismissalTimer);
    window.clearTimeout(removalTimer);
    window.clearTimeout(scrollToChoiceTimer);
    window.clearTimeout(releaseScrollTimer);
    guidedScrollActive = false;
    resetHighlights();
    resetButtonDescription();
    if (!tooltip || tooltip.hidden) return;

    tooltip.classList.remove('is-visible');
    if (immediate) {
      tooltip.hidden = true;
    } else {
      removalTimer = window.setTimeout(function () {
        if (tooltip && !tooltip.classList.contains('is-visible')) tooltip.hidden = true;
      }, 180);
    }
  }

  function concealTooltipForScroll() {
    if (!tooltip || tooltip.hidden) return;
    window.clearTimeout(removalTimer);
    tooltip.classList.remove('is-visible');
    removalTimer = window.setTimeout(function () {
      if (tooltip && !tooltip.classList.contains('is-visible')) tooltip.hidden = true;
    }, 180);
  }

  function isLinkOffscreen(link) {
    if (!link || !link.getBoundingClientRect) return false;
    var rect = link.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;

    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight;
    var safeTop = Math.min(100, Math.max(24, viewportHeight * 0.14));
    var edge = 22;

    if (rect.top < safeTop || rect.bottom > viewportHeight - edge ||
        rect.left < edge || rect.right > viewportWidth - edge) {
      return true;
    }

    var ancestor = link.parentElement;
    while (ancestor && ancestor !== document.documentElement) {
      var style = window.getComputedStyle(ancestor);
      var clippingRect = ancestor.getBoundingClientRect();
      if (/(auto|scroll|hidden|clip)/.test(style.overflowY) &&
          (rect.top < clippingRect.top || rect.bottom > clippingRect.bottom)) {
        return true;
      }
      if (/(auto|scroll|hidden|clip)/.test(style.overflowX) &&
          (rect.left < clippingRect.left || rect.right > clippingRect.right)) {
        return true;
      }
      ancestor = ancestor.parentElement;
    }
    return false;
  }

  function scrollToMissingOptions(button, link) {
    if (!link || !isLinkOffscreen(link)) return;
    scrollToChoiceTimer = window.setTimeout(function () {
      if (activeButton !== button || !link.isConnected ||
          !link.classList.contains('ph-bundle-options-attention') ||
          !isLinkOffscreen(link)) return;

      guidedScrollActive = true;
      concealTooltipForScroll();

      var reducedMotion = window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      link.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'center',
        inline: 'center'
      });

      releaseScrollTimer = window.setTimeout(function () {
        guidedScrollActive = false;
      }, reducedMotion ? 150 : 1600);
    }, 260);
  }

  function positionTooltip(button) {
    if (!tooltip || !button || tooltip.hidden) return;
    var rect = button.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight;
    var margin = 12;
    var gap = 12;
    var width = tooltip.offsetWidth;
    var height = tooltip.offsetHeight;
    var left = rect.left + rect.width / 2 - width / 2;
    left = Math.max(margin, Math.min(left, viewportWidth - width - margin));

    var top = rect.top - height - gap;
    var placement = 'above';
    if (top < margin) {
      top = rect.bottom + gap;
      placement = 'below';
    }
    top = Math.max(margin, Math.min(top, viewportHeight - height - margin));

    var pointerLeft = rect.left + rect.width / 2 - left;
    pointerLeft = Math.max(18, Math.min(pointerLeft, width - 18));
    tooltip.style.left = Math.round(left) + 'px';
    tooltip.style.top = Math.round(top) + 'px';
    tooltip.style.setProperty('--ph-guidance-pointer-left', Math.round(pointerLeft) + 'px');
    tooltip.setAttribute('data-placement', placement);
  }

  function showGuidance(button) {
    if (!isWaitingForChoices(button)) return;
    hideGuidance(true);
    ensureTooltip();

    activeButton = button;
    priorDescription = button.getAttribute('aria-describedby');
    var descriptions = priorDescription ? priorDescription + ' ' : '';
    button.setAttribute('aria-describedby', descriptions + tooltipId);

    var deal = button.closest('[data-ph-bundle-deal]');
    if (deal) {
      highlightedLinks = Array.prototype.slice.call(
        deal.querySelectorAll('[data-ph-bundle-product]')
      ).filter(function (item) {
        var checkbox = item.querySelector('[data-ph-bundle-checkbox]');
        return checkbox && checkbox.checked && !checkbox.disabled &&
          item.getAttribute('data-ph-bundle-options-required') === 'true' &&
          item.getAttribute('data-ph-bundle-selection-confirmed') !== 'true';
      }).map(function (item) {
        return item.querySelector('[data-ph-bundle-choose-options]');
      }).filter(function (link) {
        return link && !link.hidden;
      });

      highlightedLinks.forEach(function (link) {
        link.classList.remove('ph-bundle-options-attention');
        void link.offsetWidth;
        link.classList.add('ph-bundle-options-attention');
      });
    }

    tooltip.hidden = false;
    tooltip.classList.remove('is-visible');
    positionTooltip(button);
    window.requestAnimationFrame(function () {
      if (activeButton === button && tooltip && !tooltip.hidden) {
        tooltip.classList.add('is-visible');
      }
    });

    var offscreenLink = highlightedLinks.find(isLinkOffscreen);
    if (offscreenLink) scrollToMissingOptions(button, offscreenLink);

    dismissalTimer = window.setTimeout(function () { hideGuidance(false); }, 5600);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ?
      target.closest('[data-ph-bundle-button][data-ph-bundle-choice-pending="true"]') : null;

    if (button && isWaitingForChoices(button)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      showGuidance(button);
      return;
    }

    if (activeButton && (!target || !tooltip || !tooltip.contains(target))) {
      hideGuidance(false);
    }
  }, true);

  document.addEventListener('pointerdown', function (event) {
    if (!activeButton) return;
    var target = event.target;
    if (activeButton.contains(target)) return;
    if (!tooltip || !tooltip.contains(target)) hideGuidance(false);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hideGuidance(false);
  });

  window.addEventListener('scroll', function () {
    if (!guidedScrollActive) hideGuidance(false);
  }, true);
  window.addEventListener('resize', function () { hideGuidance(false); });
})();
